import { Navigate, Route, Routes } from 'react-router-dom'
import { InstancesById } from './InstanceByID/InstancesById'
import { Home } from './Home/Home'
import UsersByInstance from './Users/UsersByInstance'
import InstancesOrg from '../Organizations/Instances/InstancesOrg'
import { VerifyStateME } from './VerifyStateME/VerifyStateME'

export default function ApplicationInstances () {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path=":id" element={<InstancesById />} />
      <Route path=":id/users" element={<UsersByInstance />} />
      <Route path=":id/instance" element={<InstancesOrg />} />
      <Route path=":id/statusME" element={<VerifyStateME />} />
      <Route path="*" element={<Navigate replace to="/home" />} />
    </Routes>
  )
}
